import React, { useEffect, useState } from 'react'
import { Button, Col, Form, Row } from 'react-bootstrap'
import { Controller, useForm } from 'react-hook-form'
import { Select } from 'antd'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import moment from 'moment'
import { Checkbox } from 'antd'
import { Today } from '@mui/icons-material'
import UseExpied from '../../../../hooks/use-certificate-course-fee'
import UseExpire from '../../../../hooks/use-certificate-expire-certificate'
import UseBrand from '../../../../hooks/use-certificate-brand'
import UseLevel from '../../../../hooks/use-certificate-level'
import UseTestPass from '../../../../hooks/use-certificate-test'
import UseTypeCourse from '../../../../hooks/use-certificate-type-course'
import UsePosition from '../../../../hooks/use-certificate-type-certificate'
import { postTrainingAPI } from '../../../../services/certificate'
import Error_false from '../../../error/error-false'
import Error_500 from '../../../error/error-500'
import SwalCustom from '../../../../alert/swal-custom'
import ModalCustom from '../../../modal-custom'
import LabelCustom from '../../../label-custom'
import DatepickerCustom from '../../../datepicker-custom'
import PickerRangeCustom from '../../../datepicker-between-custom'

function ModalCertificate({
  have,

  onOpen,
  handleClose,
  fnData,
  setIsSave,
  isSave,
  orgId,
  code
}) {
  const [noCertificate, setNoCertificate] = useState(true) //true1=have false0-donthave

  const schema = yup.object().shape({
    noCertificate: yup.boolean(),
    typeOfCourse: yup.string().when('noCertificate', {
      is: false,
      then: yup.string().required('Please, Choose Type of Course')
    }),
    typeOfCertificate: yup.string().when('noCertificate', {
      is: false,
      then: yup.string().required('Please, Choose Type of Certificate')
    }),
    course: yup.string().when('noCertificate', {
      is: false,
      then: yup.string().required('Please, Fill Course')
    }),
    date: yup.array().when('noCertificate', {
      is: false,
      then: yup.array().required('Please, Choose Periods')
    }),
    typeOfProduct: yup.string().when('noCertificate', {
      is: false,
      then: yup.string().required('Please, Fill Type of Product')
    }),
    courseFee: yup.string().when('noCertificate', {
      is: false,
      then: yup.string().required('Please, Choose Course Fee')
    }),
    brand: yup.string().when('noCertificate', {
      is: false,
      then: yup.string().required('Please, Choose Brand or Partner')
    }),
    status: yup.string().when('noCertificate', {
      is: false,
      then: yup.string().required('Please, Choose Status')
    }),
    level: yup.string().when('noCertificate', {
      is: false,
      then: yup.string().required('Please, Choose Level')
    }),
    expireDateType: yup.string().when('noCertificate', {
      is: false,
      then: yup.string().required('Please, Choose Expire Date')
    })
  })

  const {
    control,
    setValue,
    setError,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  })

  const [course, setCourse] = useState()
  const [hourCourse, setHourCourse] = useState()
  const [brand, setBrand] = useState()
  const [certificate, setCertificate] = useState()
  const [level, setLevel] = useState()
  const [courseName, setCourseName] = useState()
  const [status, setStatus] = useState()
  const [startDate, setStartDate] = useState()
  const [endDate, setEndDate] = useState()
  const [certificateNo, setCertificateNo] = useState()
  const [tag, setTag] = useState()
  const [expire, setExpire] = useState()
  const [dateExpire, setDateExpire] = useState()
  const [courseFee, setCourseFee] = useState()
  const [amountFee, setAmountFee] = useState()
  const [isHaves, setIsHave] = useState(true)
  const typeExpiedYN = UseExpied()
  const typeExpense = UseExpire()
  const typeBrand = UseBrand()
  const typeLevel = UseLevel()
  const typeTestPass = UseTestPass()
  const typeCourse = UseTypeCourse()
  const typeCertificate = UsePosition()

  const date = new Date()

  const handleNoCertificate = () => {
    if (noCertificate) {
      setIsHave(false)
    } else {
      setIsHave(true)
    }
    setCourse('')
    setHourCourse('')
    setBrand('')
    setCertificate('')
    setLevel('')
    setCourseName('')
    setStatus('')
    setStartDate('')
    setEndDate('')
    setCertificateNo('')
    setTag('')
    setDateExpire('')
    setCourseFee('')
    setAmountFee('')

    setNoCertificate(!noCertificate)
  }
  const onSubmit = () => {
    setIsSave(true)

    const body = {
      orgId,
      code,
      isHave: isHaves,
      courseId: course ?? '',
      hour: hourCourse ?? hourCourse ?? '',
      partnerName: brand ?? '',
      tPositionId: certificate ?? '',
      tLevelId: level ?? '',
      courseName: courseName ?? '',
      startDate: startDate ?? moment(startDate).format('YYYY-MM-DD') ?? '',
      endDate: endDate ?? moment(endDate).format('YYYY-MM-DD') ?? '',
      statusId: status ?? '',
      certificateNo: certificateNo ?? certificateNo ?? '',
      expireId: expire ?? '',
      expireDate: dateExpire ?? '',
      expStatusId: courseFee ?? '',
      courseFee: amountFee ?? '',
      product: tag ?? ''
    }
    postTraining(body)
  }
  const postTraining = async (body) => {
    try {
      const data = await postTrainingAPI(body)
      if (data?.status) {
        SwalCustom({
          title: 'Success!',
          text: 'Your Document has been attached.',
          timer: 1500,
          showConfirmButton: false
        }).then(() => {
          handleClose()
          fnData({ orgId, code })
        })
      } else {
        Error_false(data)
      }
      setIsSave(false)
      // handleClose()
    } catch (error) {
      Error_500(error)
      setIsSave(false)
    }
  }
  return (
    <ModalCustom width={800} open={onOpen} onCancel={handleClose}>
      <Form
        onSubmit={handleSubmit(onSubmit)}
        className="mt-3 row"
        style={{ rowGap: '13px' }}
      >
        <label>Certificate</label>

        <Row style={{ rowGap: '15px' }}>
          <Col md={6}>
            {!noCertificate ? (
              <Col md={12} className="mt-2">
                <LabelCustom text={'Type of Course'} />{' '}
                <span className="text-danger">*</span>
                <Form.Control
                  className="w-100 mt-2"
                  disabled={!noCertificate}
                />
              </Col>
            ) : (
              <Col md={12} className="mt-2">
                <LabelCustom text={'Type of Course'} />{' '}
                <span className="text-danger">*</span>
                <Controller
                  name={'typeOfCourse'}
                  control={control}
                  render={({ field: { onChange, value = '' } }) => (
                    <>
                      {course === 3 ? (
                        <>
                          <div className="col-12 d-flex gap-2">
                            <div className="col-6">
                              <Select
                                className="w-100 mt-2"
                                options={typeCourse}
                                value={course}
                                onChange={(value) => {
                                  onChange(value)
                                  setCourse(value)
                                }}
                              />
                            </div>
                            <div className="col-6 mt-2">
                              <Form.Control
                                className="w-100 "
                                placeholder="Hours*"
                                onChange={(e) => {
                                  onChange(e)
                                  setHourCourse(e.target.value)
                                }}
                              />
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          {' '}
                          <Select
                            className="w-100 mt-2"
                            options={typeCourse}
                            value={value}
                            disabled={!noCertificate}
                            onChange={(value) => {
                              onChange(value)
                              setCourse(value)
                            }}
                          />
                        </>
                      )}
                    </>
                  )}
                />
                {errors.typeOfCourse?.message && (
                  <label className="small text-danger">
                    {errors.typeOfCourse.message}
                  </label>
                )}
              </Col>
            )}

            {!noCertificate ? (
              <Col md={12} className="mt-2">
                <LabelCustom text={'Type of Certificate'} />{' '}
                <span className="text-danger">*</span>
                <Form.Control
                  className="w-100 mt-2"
                  disabled={!noCertificate}
                />
              </Col>
            ) : (
              <Col md={12} className="mt-2">
                <LabelCustom text={'Type of Certificate'} />{' '}
                <span className="text-danger">*</span>
                <Controller
                  name={'typeOfCertificate'}
                  control={control}
                  render={({ field: { onChange, value = '' } }) => (
                    <Select
                      className="w-100 mt-2"
                      options={typeCertificate}
                      value={value}
                      disabled={!noCertificate}
                      onChange={(value) => {
                        onChange(value)
                        setCertificate(value)
                      }}
                    />
                  )}
                />
                {errors.typeOfCertificate?.message && (
                  <label className="small text-danger">
                    {errors.typeOfCertificate.message}
                  </label>
                )}
              </Col>
            )}

            {!noCertificate ? (
              <Col md={12} className="mt-2">
                <LabelCustom text={'Course/ Exam Name'} />{' '}
                <span className="text-danger">*</span>
                <Form.Control
                  className="w-100 mt-2"
                  disabled={!noCertificate}
                />
              </Col>
            ) : (
              <Col md={12} className="mt-2">
                <LabelCustom text={'Course/ Exam Name'} />{' '}
                <span className="text-danger">*</span>
                <Controller
                  name={'course'}
                  control={control}
                  render={({ field: { onChange, value = '' } }) => (
                    <Form.Control
                      className="w-100 mt-2"
                      value={value}
                      disabled={!noCertificate}
                      onChange={(e) => {
                        onChange(e)
                        setCourseName(e.target.value)
                      }}
                    />
                  )}
                />
                {errors.course?.message && (
                  <label className="small text-danger">
                    {errors.course.message}
                  </label>
                )}
              </Col>
            )}

            {!noCertificate ? (
              <Col md={12} className="mt-2">
                <LabelCustom text={'Periods'} />{' '}
                <span className="text-danger">*</span>
                <Form.Control
                  className="w-100 mt-2"
                  disabled={!noCertificate}
                />
              </Col>
            ) : (
              <Col md={12} className="mt-2">
                <LabelCustom text={'Periods'} />{' '}
                <span className="text-danger">*</span>
                <Controller
                  name={'date'}
                  control={control}
                  render={({ field: { onChange, value = '' } }) => (
                    <PickerRangeCustom
                      value={value}
                      disabled={!noCertificate}
                      onChange={(date) => {
                        if (date.length > 1) {
                          const st = moment(date[0]).format('YYYY-MM-DD')
                          const en = moment(date[1]).format('YYYY-MM-DD')
                          setValue('date', [st, en])
                          setStartDate(st)
                          setEndDate(en)
                        } else if (date.length === 0) {
                          setValue('date', ['', ''])
                        }
                      }}
                    />
                  )}
                />
                {errors.date?.message && (
                  <label className="small text-danger">
                    {errors.date.message}
                  </label>
                )}
              </Col>
            )}

            {!noCertificate ? (
              <Col md={12} className="mt-2">
                <LabelCustom text={'Type of Product (Tag)'} />{' '}
                <span className="text-danger">*</span>
                <Form.Control
                  className="w-100 mt-2"
                  disabled={!noCertificate}
                />
              </Col>
            ) : (
              <Col md={12} className="mt-2">
                <LabelCustom text={'Type of Product (Tag)'} />{' '}
                <span className="text-danger">*</span>
                <Controller
                  name={'typeOfProduct'}
                  control={control}
                  render={({ field: { onChange, value = '' } }) => (
                    <Form.Control
                      className="w-100 mt-2"
                      value={value}
                      disabled={!noCertificate}
                      onChange={(e) => {
                        onChange(e)
                        setTag(e.target.value)
                      }}
                    />
                  )}
                />
                {errors.typeOfProduct?.message && (
                  <label className="small text-danger">
                    {errors.typeOfProduct.message}
                  </label>
                )}
              </Col>
            )}

            {!noCertificate ? (
              <Col md={12} className="mt-2">
                <LabelCustom text={'Course Fee'} />{' '}
                <span className="text-danger">*</span>
                <Form.Control
                  className="w-100 mt-2"
                  disabled={!noCertificate}
                />
              </Col>
            ) : (
              <Col md={12} className="mt-2">
                <LabelCustom text={'Course Fee'} />{' '}
                <span className="text-danger">*</span>
                <Controller
                  name={'courseFee'}
                  control={control}
                  render={({ field: { onChange, value = '' } }) => (
                    <>
                      {value == 2 ? (
                        <>
                          <div className="col-12 d-flex gap-2 mt-2">
                            <div className="col-6">
                              <Select
                                className="w-100"
                                options={typeExpense}
                                value={value}
                                onChange={(value) => {
                                  onChange(value)
                                  setCourseFee(value)
                                }}
                              />
                            </div>
                            <div className="col-6 ">
                              <Form.Control
                                className="w-100 "
                                placeholder="Amount*"
                                onChange={(e) => {
                                  setAmountFee(e.target.value)
                                }}
                              />
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <Select
                            className="w-100 mt-2"
                            options={typeExpense}
                            value={value}
                            disabled={!noCertificate}
                            onChange={(value) => {
                              onChange(value)
                              setCourseFee(value)
                            }}
                          />
                        </>
                      )}
                    </>
                  )}
                />
                {errors.courseFee?.message && (
                  <label className="small text-danger">
                    {errors.courseFee.message}
                  </label>
                )}
              </Col>
            )}
          </Col>

          <Col md={6}>
            {!noCertificate ? (
              <Col md={12} className="mt-2">
                <LabelCustom text={'Brand/ Partner'} />{' '}
                <span className="text-danger">*</span>
                <Form.Control
                  className="w-100 mt-2"
                  disabled={!noCertificate}
                />
              </Col>
            ) : (
              <Col md={12} className="mt-2">
                <LabelCustom text={'Brand/ Partner'} />{' '}
                <span className="text-danger">*</span>
                <Controller
                  name={'brand'}
                  control={control}
                  render={({ field: { onChange, value = '' } }) => (
                    <Select
                      options={typeBrand}
                      className="w-100 mt-2"
                      value={value}
                      disabled={!noCertificate}
                      onChange={(value) => {
                        onChange(value)
                        setBrand(value)
                      }}
                    />
                  )}
                />
                {errors.brand?.message && (
                  <label className="small text-danger">
                    {errors.brand.message}
                  </label>
                )}
              </Col>
            )}

            {!noCertificate ? (
              <Col md={12} className="mt-2">
                <LabelCustom text={'Level'} />{' '}
                <span className="text-danger">*</span>
                <Form.Control
                  className="w-100 mt-2"
                  disabled={!noCertificate}
                />
              </Col>
            ) : (
              <Col md={12} className="mt-2">
                <LabelCustom text={'Level'} />{' '}
                <span className="text-danger">*</span>
                <Controller
                  name={'level'}
                  control={control}
                  render={({ field: { onChange, value = '' } }) => (
                    <Select
                      className="w-100 mt-2"
                      options={typeLevel}
                      value={value}
                      disabled={!noCertificate}
                      onChange={(value) => {
                        onChange(value)
                        setLevel(value)
                      }}
                    />
                  )}
                />
                {errors.level?.message && (
                  <label className="small text-danger">
                    {errors.level.message}
                  </label>
                )}
              </Col>
            )}

            {!noCertificate ? (
              <Col md={12} className="mt-2">
                <LabelCustom text={'Status'} />{' '}
                <span className="text-danger">*</span>
                <Form.Control
                  className="w-100 mt-2"
                  disabled={!noCertificate}
                />
              </Col>
            ) : (
              <Col md={12} className="mt-2">
                <LabelCustom text={'Status'} />{' '}
                <span className="text-danger">*</span>
                <Controller
                  name={'status'}
                  control={control}
                  render={({ field: { onChange, value = '' } }) => (
                    <Select
                      options={typeTestPass}
                      className="w-100 mt-2"
                      value={value}
                      disabled={!noCertificate}
                      onChange={(value) => {
                        onChange(value)
                        setStatus(value)
                      }}
                    />
                  )}
                />
                {errors.status?.message && (
                  <label className="small text-danger">
                    {errors.status.message}
                  </label>
                )}
              </Col>
            )}

            {!noCertificate ? (
              <Col md={12} className="mt-2">
                <LabelCustom text={'Certificate No.'} />{' '}
                <span className="text-danger">*</span>
                <Form.Control
                  className="w-100 mt-2"
                  disabled={!noCertificate}
                />
              </Col>
            ) : (
              <Col md={12} className="">
                <LabelCustom text={'Certificate No.'} />{' '}
                <Controller
                  name={'certificateNo'}
                  control={control}
                  render={({ field: { onChange, value = '' } }) => (
                    <Form.Control
                      className="w-100 mt-2"
                      value={value}
                      disabled={!noCertificate}
                      onChange={(e) => {
                        onChange(e)
                        setCertificateNo(e.target.value)
                      }}
                    />
                  )}
                />
                {errors.certificateNo?.message && (
                  <label className="small text-danger">
                    {errors.certificateNo.message}
                  </label>
                )}
              </Col>
            )}

            {!noCertificate ? (
              <Col md={12} className="mt-2">
                <LabelCustom text={'Expire Date of Certificate'} />{' '}
                <span className="text-danger">*</span>
                <Form.Control
                  className="w-100 mt-2"
                  disabled={!noCertificate}
                />
              </Col>
            ) : (
              <Col md={12} className="mt-3">
                <LabelCustom text={'Expire Date of Certificate'} />{' '}
                <span className="text-danger">*</span>
                <Controller
                  name={'expireDateType'}
                  control={control}
                  render={({ field: { onChange, value = '' } }) => (
                    <>
                      {value == 2 ? (
                        <>
                          <div className="col-12 d-flex gap-2 ">
                            <div className="col-6">
                              <Select
                                className="w-100"
                                options={typeExpiedYN}
                                value={value}
                                onChange={(value) => {
                                  onChange(value) // Update the value of typeOfCourse
                                  setExpire(value)
                                }}
                              />
                            </div>
                            <div className="col-6 ">
                              <DatepickerCustom
                                className="w-100 mt-2"
                                value={moment(date).format('DD/MM/YYYY')}
                                isClearable
                                onChange={([date]) => {
                                  setDateExpire(
                                    date
                                      ? moment(date).format('YYYY-MM-DD')
                                      : ''
                                  )
                                  setError('expireDateType', false)
                                }}
                              />
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <Select
                            className="w-100 "
                            options={typeExpiedYN}
                            value={value}
                            disabled={!noCertificate}
                            onChange={(value) => {
                              onChange(value)
                              setExpire(value)
                            }}
                          />
                        </>
                      )}
                    </>
                  )}
                />
                {errors.expireDateType?.message && (
                  <label className="small text-danger">
                    {errors.expireDateType.message}
                  </label>
                )}
              </Col>
            )}
            <Col xl={12}>
              {have?.status_id === 0 || have?.status_id === 1 ? (
                <></>
              ) : (
                <div className="mt-2">
                  <Checkbox onClick={handleNoCertificate} /> No Certificate
                </div>
              )}
            </Col>
          </Col>

          <Col xl={12} className="text-center mt-3">
            <Button
              className="px-5 text-primary me-4"
              variant="light"
              type="button"
              disabled={isSave}
              onClick={handleClose}
            >
              Close
            </Button>
            <Button className="px-5 " disabled={isSave} type="submit">
              {isSave ? 'Saving...' : 'Save'}
            </Button>
          </Col>
        </Row>
      </Form>
    </ModalCustom>
  )
}

export default ModalCertificate
